import { AccredibleLocaleDatePipeModule } from '@accredible-frontend-v2/pipes/locale-date';
import { NgModule } from '@angular/core';
import { AccredibleAttributeService } from './attribute.service';

@NgModule({
  imports: [AccredibleLocaleDatePipeModule],
  providers: [AccredibleAttributeService],
})
export class AccredibleAttributeServiceModule {}
